import { type HTMLAttributes, type ReactNode } from 'react';

type CardVariant = 'default' | 'elevated' | 'growth' | 'stress' | 'calm';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  children: ReactNode;
}

interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  action?: ReactNode;
}

interface CardBodyProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({
  variant = 'default',
  children,
  className = '',
  ...props
}: CardProps) {
  const variantClass = variant !== 'default' ? `card-${variant}` : '';

  return (
    <div className={`card ${variantClass} ${className}`.trim()} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({
  title,
  action,
  className = '',
  ...props
}: CardHeaderProps) {
  return (
    <div className={`card-header ${className}`.trim()} {...props}>
      <h3 className="card-title">{title}</h3>
      {action}
    </div>
  );
}

export function CardBody({ children, className = '', ...props }: CardBodyProps) {
  return (
    <div className={`card-body ${className}`.trim()} {...props}>
      {children}
    </div>
  );
}
